import { getContentByRef } from './get-content-by-ref.js';

function getPrescriptionEntryList(configuratorDocumentRef, pageModel) {
    if (!pageModel) {
        return undefined;
    }
    var ref2;
    const { prescriptionStepEntryTypes  } = (ref2 = getContentByRef(configuratorDocumentRef === null || configuratorDocumentRef === void 0 ? void 0 : configuratorDocumentRef.$ref, pageModel)) !== null && ref2 !== void 0 ? ref2 : {};
    if (!prescriptionStepEntryTypes || prescriptionStepEntryTypes.length === 0) {
        return undefined;
    }
    return prescriptionStepEntryTypes.map((item)=>{
        var ref, ref1;
        return {
            key: item.key,
            title: item.iconTextCompound[0].text,
            icon: !!((ref = item.iconTextCompound[0]) === null || ref === void 0 ? void 0 : ref.icon) ? (ref1 = item.iconTextCompound[0]) === null || ref1 === void 0 ? void 0 : ref1.icon : undefined,
            description: !!item.description.value ? item.description.value : undefined,
            ctaLabel: !!item.ctaLabel ? item.ctaLabel : undefined
        };
    });
}

export { getPrescriptionEntryList };
//# sourceMappingURL=get-prescription-entry-list.js.map
